import {ConfigContext} from './config/context/index.js'
import Config, {APP_NAME_MOTOS} from './config/index.js'
import Motor from './Motor.js'

/**
 *  Class representing Motos application
 *  @class
 */
class Motos extends Motor {
  /**
   * @constructor
   * @param {Object} deps
   * @param {String} deps.appName
   */
  constructor(logger) {
    const config = new Config({appName: APP_NAME_MOTOS})

    ConfigContext.initialize(config)

    super({
      config,
      logger
    })
  }
}

/**
 * @exports default Motos
 */
export default Motos
